import type { Survey } from '@/data-access/surveys/types'
import { getHighestVotedOption } from '@/utils/polls/votes'
import { cn } from '@/lib/utils'
import { PollContainer, Header, QuestionBlock, AnswerBlock, CountdownLabel, labelStyles } from './atoms'

export function EndedPollInfo({ survey, className }: { survey: Survey; className?: string }) {
	const highestVotedOption = getHighestVotedOption(survey.answers)

	return (
		<PollContainer className={className}>
			<Header date={survey.endDate} />

			<QuestionBlock pollType="ended" question={survey.question} />

			{survey.answers?.length ? (
				<AnswerBlock
					label={props => (
						<span className={cn(props.className, labelStyles({ pollType: 'ended' }))}>Winning Answer</span>
					)}
				>
					<img src={highestVotedOption.icon as string} className="size-10 flex-shrink-0" />
					<span
						className="text-2xl leading-6 overflow-hidden text-ellipsis line-clamp-2"
						title={highestVotedOption.description}
					>
						{highestVotedOption.description}
					</span>
				</AnswerBlock>
			) : null}
		</PollContainer>
	)
}

export function OngoingPollInfo({
	survey,
	onTimerEnd,
	className
}: {
	survey: Survey
	onTimerEnd?: () => void
	className?: string
}) {
	const highestVotedOption = getHighestVotedOption(survey.answers)

	return (
		<PollContainer className={className}>
			<Header date={survey.endDate} />

			<QuestionBlock pollType="ongoing" question={survey.question} />

			{survey.answers?.length ? (
				<AnswerBlock
					label={props => (
						<CountdownLabel
							className={cn(props.className, labelStyles({ pollType: 'ongoing' }))}
							targetDate={survey.endDate}
							label="Ends in"
							onEnd={onTimerEnd}
						/>
					)}
				>
					<img src={highestVotedOption.icon as string} className="size-10 flex-shrink-0" />
					<span
						className="text-2xl leading-6 overflow-hidden text-ellipsis line-clamp-2"
						title={highestVotedOption.description}
					>
						{highestVotedOption.description}
					</span>
				</AnswerBlock>
			) : null}
		</PollContainer>
	)
}

export function UpcomingPollInfo({
	survey,
	onTimerEnd,
	className
}: {
	survey: Survey
	onTimerEnd?: () => void
	className?: string
}) {
	return (
		<PollContainer className={className}>
			<Header date={survey.startDate} />

			<QuestionBlock pollType="upcoming" question={survey.question} />

			{survey.answers?.length ? (
				<AnswerBlock
					label={props => (
						<CountdownLabel
							className={cn(props.className, labelStyles({ pollType: 'upcoming' }))}
							targetDate={survey.startDate}
							label="Starts in"
							onEnd={onTimerEnd}
						/>
					)}
				>
					<img src="/images/question-mark.svg" alt="Question Mark" className="size-8 flex-shrink-0" />
				</AnswerBlock>
			) : null}
		</PollContainer>
	)
}
